export default "__VITE_ASSET__6d9b726d__"